import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import { Link } from "react-router-dom";
import GameIcon from "@material-ui/icons/VideogameAsset";
import KeyboardIcon from "@material-ui/icons/KeyboardOutlined";
import { Box } from "@material-ui/core";

const styles = {
  card: {
    width: "auto",
    margin: "0px"
  },
  media: {
    height: 60
  },
  btn: {
    marginTop: '15px',
    marginRight: '15px',
  }
};

function MediaCard(props) {
  const { classes } = props;
  return (
    <Box className={classes.card}
    >
      {/* <CardMedia
        className={classes.media}
        image="https://www.interact-intranet.com/wp-content/themes/interact/assets/img/teams.png"
        title="Collaboration"
      /> */}
      <Box>
        <Typography gutterBottom variant="subtitle2" component="h2">
          Collaborate & Help
        </Typography>
        <Typography variant="body2" color="textSecondary">
          Aakhor is <span className="redHighlight">under word correction</span>{" "}
          process now. Play our verification game and help us verify words.
        </Typography>
      </Box>

      <Button component={Link} to={"/typing-game"} size={"small"} variant="outlined" className={classes.btn}>
        <KeyboardIcon style={{ marginRight: 10 }} />
          Typing game
        </Button>

        <Button component={Link} to={"/word-game"} size={"small"} variant="outlined" className={classes.btn}>
          <GameIcon style={{ marginRight: 10 }} />
          Word game
        </Button>
    </Box>
  );
}

MediaCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(MediaCard);
